import _ from 'lodash';
// @ts-ignore
import { getAuthItem } from 'kubra-lib-react-auth/dist';

/**
 * Get an object containing the options that are common across all IAM API requests
 * @param {*} options
 */
export interface RequestOptions {
  headers?: object;
  [key: string]: any;
}

const getRequestOptions = (options?: RequestOptions): object => {
  const token = getAuthItem('accessToken');

  return {
    ...options,
    headers: {
      // add bearer token to headers
      Authorization: `Bearer ${token}`,
      // spread headers if exists on input options
      ..._.get(options, 'headers', {}),
    },
  };
};

export default getRequestOptions;
